const testimonials = [
  {
    name: "Patricia H.",
    location: "Albany, GA",
    rating: 5,
    text: "My husband got last-minute orders for deployment and his passport was expired. We live in Albany and didn't think we had time. Fast Passport Center walked us through everything, had him ship from the local UPS store, and he got his emergency passport in 4 days. Saved his trip.",
    service: "Emergency Passport",
  },
  {
    name: "Derek L.",
    location: "Cordele, GA",
    rating: 5,
    text: "Business conference in Toronto got moved up to two weeks out. I was panicking because I'm in Cordele — not close to any big city. Started online, shipped from Albany overnight, and had my expedited passport in hand with a week to spare. Unreal service.",
    service: "Passport Renewal",
  },
  {
    name: "Monica R.",
    location: "Americus, GA",
    rating: 5,
    text: "We booked a cruise to the Caribbean and realized my daughter's passport was expired a month before sailing. From Americus, we didn't know where to turn. Fast Passport Center told us exactly what to do at the Albany Post Office for the clerk visit and handled the rest. Made it with time to spare.",
    service: "Child Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function AlbanyTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Southwest Georgia Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Albany, Cordele, Americus, and southwest Georgia who trusted Fast Passport Center with their emergency and expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}